import { render, staticRenderFns } from "./FreightReview.vue?vue&type=template&id=c6123744&"
import script from "./FreightReview.vue?vue&type=script&lang=js&"
export * from "./FreightReview.vue?vue&type=script&lang=js&"
import style0 from "./FreightReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports